/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.dev/license
 */

// THIS CODE IS GENERATED - DO NOT MODIFY.
const u = undefined;

function plural(val: number): number {
const n = val, i = Math.floor(Math.abs(val)), v = val.toString().replace(/^[^.]*\.?/, '').length;

if (i === 1 && v === 0)
    return 1;
return 5;
}

export default ["et",[["AM","PM"]],u,[["P","E","T","K","N","R","L"],u,["pÃ¼hapÃ¤ev","esmaspÃ¤ev","teisipÃ¤ev","kolmapÃ¤ev","neljapÃ¤ev","reede","laupÃ¤ev"],["P","E","T","K","N","R","L"]],u,[["J","V","M","A","M","J","J","A","S","O","N","D"],["jaan","veebr","mÃ¤rts","apr","mai","juuni","juuli","aug","sept","okt","nov","dets"],["jaanuar","veebruar","mÃ¤rts","aprill","mai","juuni","juuli","august","september","oktoober","november","detsember"]],u,[["eKr","pKr"],u,["enne Kristust","pÃ¤rast Kristust"]],1,[6,0],["dd.MM.yy","d. MMM y","d. MMMM y","EEEE, d. MMMM y"],["HH:mm","HH:mm:ss","HH:mm:ss z","HH:mm:ss zzzz"],["{1} {0}",u,u,u],[",","Â ",";","%","+","â","Ã10^","Ã","â°","â","NaN",":"],["#,##0.###","#,##0%","#,##0.00Â Â¤","#E0"],"EUR","â¬","euro",{"AUD":["AU$","$"],"EEK":["kr"],"PHP":[u,"â±"],"THB":["à¸¿"],"TWD":["NT$"]},"ltr", plural];
